import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const row = css`
  display: flex;
  margin-bottom: 1rem;
`;

export const title = css`
  margin: 2rem 0 1rem 0;
  text-align: center;
`;

export const subTitle = css`
  text-align: center;
  margin-bottom: 1.5rem;

  @media (min-width: ${dimensions.tablet}) {
    padding: 0 4rem;
  }
`;

export const name = css`
  display: flex;
  width: 100%;
`;

export const tooltip = css`
  padding: 1rem;
  margin-right: -3rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-right: 0;
    padding: 0.75rem 0px 0.75rem 0.75rem;
  }
`;

export const buttonTooltip = css`
  width: 100%;
`;

export const helpButton = css`
  margin-top: -1rem;

  @media (max-width: ${dimensions.tablet}) {
    margin-top: 0.5rem;
  }
`;
